import {booleanAttribute, Component, Input, ViewChild} from '@angular/core';
import {NgClass} from '@angular/common';

import {BoiteDialogueGeneriqueComponent, SimpleBoutonComponent, SimpleLibelleComponent, SimpleImageComponent} from "../../../../val-composants-lib/src/public-api";

//Composant boîte de dialogue RG simple
@Component (
{
  selector: 'val-boite-dialogue-rg-simple',
  imports: 
  [
    NgClass,
    BoiteDialogueGeneriqueComponent,
    SimpleBoutonComponent,
    SimpleLibelleComponent,
    SimpleImageComponent
  ],
  templateUrl: './boite-dialogue-rg-simple.component.html',
  styleUrl: './boite-dialogue-rg-simple.component.scss'
})
export class BoiteDialogueRgSimpleComponent 
{
  //Création
  constructor () 
  {
    this.titre = "";
    this.boutonOkVisible = false;
    this.boutonAnnulerVisible = false;
    this.boutonAbandonnerVisible = false;
    this.boutonRecommencerVisible = false;
    this.boutonIgnorerVisible = false;
    this.boutonOuiVisible = false;
    this.boutonNonVisible = false;
    this.message = "";
    this.iconeVisible = false;
    this.icone = "";
  }

  //Boîte de dialogue
  @ViewChild ("boiteDialogue")
  public boiteDialogue!: BoiteDialogueGeneriqueComponent<number>;

  //Titre
  @Input ()
  public titre: string;

  //Indique si le bouton ok est visible
  @Input ({transform: booleanAttribute})
  public boutonOkVisible: boolean;

  //Indique si le bouton annuler est visible
  @Input ({transform: booleanAttribute})
  public boutonAnnulerVisible: boolean;

  //Indique si le bouton abandonner est visible
  @Input ({transform: booleanAttribute})
  public boutonAbandonnerVisible: boolean;

  //Indique si le bouton recommencer est visible
  @Input ({transform: booleanAttribute})
  public boutonRecommencerVisible: boolean;

  //Indique si le bouton ignorer est visible
  @Input ({transform: booleanAttribute})
  public boutonIgnorerVisible: boolean;

  //Indique si le bouton oui est visible
  @Input ({transform: booleanAttribute})
  public boutonOuiVisible: boolean;

  //Indique si le bouton non est visible
  @Input ({transform: booleanAttribute})
  public boutonNonVisible: boolean;

  //Message
  @Input ()
  public message: string;

  //Indique si l’icone est visible
  @Input ({transform: booleanAttribute})
  public iconeVisible: boolean;

  //Icone
  @Input ()
  public icone: string;

  //Ouvre la boite de dialogue
  //  Retourne
  //    Code du bouton
  public async Ouvrir () : Promise<number> 
  {
    let operation: Promise<number>;

    operation = this.boiteDialogue.Ouvrir ();

    return operation;
  }

  //Bouton click
  //  Paramètres
  //    identifiant : Identifiant du bouton
  public BoutonClick (identifiant: number) : void 
  {
    this.boiteDialogue.fonctionRetour (identifiant);
    this.boiteDialogue.Fermer ();
  }
}
